<header class="site-header">
  <div class="header-inner">

    <!-- Logo -->
    <a class="header-logo" routerLink="/" (click)="closeMenu()">
      <img src="assets/images/logo.png" alt="Kontakta" width="155" height="51" />
    </a>

    <!-- Desktop nav -->
    <nav class="header-nav" aria-label="Main navigation">
      <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenu()">
        {{ 'header.home' | translate }}
      </a>
      <a class="nav-link" routerLink="/about" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.about' | translate }}
      </a>

      <div class="nav-dropdown" [class.open]="isServicesOpen()">
        <button class="nav-link nav-dropdown-toggle" type="button" (click)="toggleServices($event)">
          {{ 'header.services.title' | translate }}
          <span class="dropdown-arrow">▾</span>
        </button>
        @if (isServicesOpen()) {
          <div class="nav-dropdown-menu">
            <a class="nav-dropdown-item" routerLink="/services" (click)="closeMenu()">
              {{ 'header.services.civilians' | translate }}
            </a>
            <a class="nav-dropdown-item" routerLink="/work-safety" (click)="closeMenu()">
              {{ 'header.services.workSafety' | translate }}
            </a>
          </div>
        }
      </div>

      <a class="nav-link" routerLink="/questions" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.questions' | translate }}
      </a>
      <a class="nav-link" routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.contact' | translate }}
      </a>
      <a class="nav-link" routerLink="/news" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.news' | translate }}
      </a>
    </nav>

    <!-- Desktop actions: language + CTA -->
    <div class="header-actions">
      <div class="lang-switcher" [class.open]="isLangOpen()">
        <button class="lang-toggle" type="button" (click)="toggleLang($event)">
          <img [src]="currentFlag()" [alt]="currentLanguage()" class="flag-icon" width="20" height="15" />
          <span>{{ currentLanguage() === 'sr' ? ('header.serbian' | translate) : ('header.english' | translate) }}</span>
          <span class="dropdown-arrow">▾</span>
        </button>
        @if (isLangOpen()) {
          <div class="lang-menu">
            <button class="lang-option" type="button" (click)="switchLanguage('sr', $event)">
              <img src="assets/images/sr.png" alt="Serbian" class="flag-icon" width="20" height="15" />
              {{ 'header.serbian' | translate }}
            </button>
            <button class="lang-option" type="button" (click)="switchLanguage('en', $event)">
              <img src="assets/images/us.png" alt="English" class="flag-icon" width="20" height="15" />
              {{ 'header.english' | translate }}
            </button>
          </div>
        }
      </div>

      <a routerLink="/signup" class="btn-primary header-cta" (click)="closeMenu()">
        {{ 'header.cta' | translate }}
      </a>
    </div>

    <!-- Hamburger (mobile only) -->
    <button
      class="hamburger"
      type="button"
      [class.open]="isMenuOpen()"
      (click)="toggleMenu()"
      aria-label="Toggle navigation"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>

  <!-- Mobile menu -->
  @if (isMenuOpen()) {
    <div class="mobile-menu">
      <a class="mobile-nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenu()">
        {{ 'header.home' | translate }}
      </a>
      <a class="mobile-nav-link" routerLink="/about" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.about' | translate }}
      </a>

      <div class="mobile-nav-group">
        <button class="mobile-nav-link mobile-nav-toggle" type="button" (click)="toggleServices($event)">
          {{ 'header.services.title' | translate }}
          <span class="dropdown-arrow" [class.rotated]="isServicesOpen()">▾</span>
        </button>
        @if (isServicesOpen()) {
          <div class="mobile-nav-submenu">
            <a class="mobile-nav-sublink" routerLink="/services" (click)="closeMenu()">
              {{ 'header.services.civilians' | translate }}
            </a>
            <a class="mobile-nav-sublink" routerLink="/work-safety" (click)="closeMenu()">
              {{ 'header.services.workSafety' | translate }}
            </a>
          </div>
        }
      </div>

      <a class="mobile-nav-link" routerLink="/questions" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.questions' | translate }}
      </a>
      <a class="mobile-nav-link" routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.contact' | translate }}
      </a>
      <a class="mobile-nav-link" routerLink="/news" routerLinkActive="active" (click)="closeMenu()">
        {{ 'header.news' | translate }}
      </a>

      <div class="mobile-lang">
        <button class="mobile-lang-btn" type="button" (click)="switchLanguage('sr', $event)">
          <img src="assets/images/sr.png" alt="Serbian" class="flag-icon" width="20" height="15" />
          {{ 'header.serbian' | translate }}
        </button>
        <button class="mobile-lang-btn" type="button" (click)="switchLanguage('en', $event)">
          <img src="assets/images/us.png" alt="English" class="flag-icon" width="20" height="15" />
          {{ 'header.english' | translate }}
        </button>
      </div>

      <a routerLink="/signup" class="btn-primary mobile-cta" (click)="closeMenu()">
        {{ 'header.cta' | translate }}
      </a>
    </div>
  }
</header>
